/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AccessRequestsAppAccessRulePatchRequest
 */
export interface AccessRequestsAppAccessRulePatchRequest {
    /**
     * 
     * @type {string}
     * @memberof AccessRequestsAppAccessRulePatchRequest
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof AccessRequestsAppAccessRulePatchRequest
     */
    app_url?: string;
    /**
     * 
     * @type {string}
     * @memberof AccessRequestsAppAccessRulePatchRequest
     */
    identifier_from_source?: string;
}

/**
 * Check if a given object implements the AccessRequestsAppAccessRulePatchRequest interface.
 */
export function instanceOfAccessRequestsAppAccessRulePatchRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AccessRequestsAppAccessRulePatchRequestFromJSON(json: any): AccessRequestsAppAccessRulePatchRequest {
    return AccessRequestsAppAccessRulePatchRequestFromJSONTyped(json, false);
}

export function AccessRequestsAppAccessRulePatchRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccessRequestsAppAccessRulePatchRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'description': !exists(json, 'description') ? undefined : json['description'],
        'app_url': !exists(json, 'app_url') ? undefined : json['app_url'],
        'identifier_from_source': !exists(json, 'identifier_from_source') ? undefined : json['identifier_from_source'],
    };
}

export function AccessRequestsAppAccessRulePatchRequestToJSON(value?: AccessRequestsAppAccessRulePatchRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'description': value.description,
        'app_url': value.app_url,
        'identifier_from_source': value.identifier_from_source,
    };
}

